import React from 'react';


import { useDispatch } from 'react-redux'
import { useObjectSelector, getObject } from '../redux/hooks'



function ObjectName(props) {

    const dispatch = useDispatch()
    const objectId = props.url
    const objectSelector = useObjectSelector(objectId)
    const object = getObject(objectId, objectSelector, dispatch)


    return (
        <span>{object() !== "UNKNOWN" ?
            object().name
            :
            "..."
        }</span>


    );
}

export default ObjectName;